let moduleName = "";

function processVideos(iframes, parsedData) {
  for (let i = 0; i < iframes.length; i++) {
    let videoId = "";
    if (moduleName == "ACTIVITY") {
      let vidId = iframes[i].src && iframes[i].src.split("activityconvertedvideos/")[1];
      let newId = vidId && vidId.split("/");
      videoId = newId && newId.length > 0 && newId[1];
    } else {
      let vidId = iframes[i].src && iframes[i].src.split("video/")[1];
      let newId = vidId && vidId.split("/");
      videoId = newId && newId[0];
    }
    if (videoId) {
      let videoElement = document.createElement("video");
      let sourceElement = document.createElement("source");
      videoElement.setAttribute("style", "width: 100%; max-width: 300px; max-height: 150px; height: 150px; background-color: black;");
      videoElement.setAttribute("controls", "");
      sourceElement.src = encodeURI(parsedData[videoId]);
      sourceElement.type = "video/mp4";
      videoElement.appendChild(sourceElement);
      iframes[i].parentNode && iframes[i].parentNode.insertBefore(videoElement, iframes[i]);
      iframes[i].setAttribute("style", "display: none;");
    }
  }
}

function setS3SignedUrl(element, data) {
  let iframes = element.getElementsByTagName("iframe");
  let parsedData = JSON.parse(data);
  if (iframes && iframes.length) {
    processVideos(iframes, parsedData);
  }
}

function getS3SignedUrl(element, iframes) {
  let script = element.getElementsByTagName("script");
  let info = { domainName: null, studyID: null, clientID: null, moduleName: null, videoId: null, activityId: null };
  if (script.length == 0) {
    if (iframes.length > 0) {
      let videoIds = [];
      for (let i = 0; i < iframes.length; i++) {
        if (iframes[i].src.includes("activityconvertedvideos")) {
          let videoURL = iframes[i].src.split("?")[0];
          let splitUrl = videoURL.split("/");
          videoIds.push(splitUrl[splitUrl.length - 1]);
          info["activityId"] = splitUrl[splitUrl.length - 2];
        } else {
          return;
        }
      }
      info["videoId"] = videoIds.join();
      info["domainName"] = process.env.VUE_APP_API_BASE_URL;
      info["clientID"] = window.localStorage.getItem("thread-clientId");
      info["moduleName"] = "ACTIVITY";
    }
  } else {
    let paramsArr = script[script.length - 1].src.split("?")[1].split("&");
    for (let i = 0; i < paramsArr.length; i++) {
      let args = paramsArr[i].split("=");
      info[args[0]] = args[1];
    }
  }
  moduleName = info["moduleName"];
  let theUrl = "";
  if (info["moduleName"] && info["moduleName"] !== null) {
    if (moduleName == "ACTIVITY") {
      theUrl = info["domainName"] + "/api/v1/studymanagement/activity/" + info["activityId"] + "/signedvideosurl?videoId=" + info["videoId"];
    } else {
      theUrl = info["domainName"] + "/api/v1/studymanagement/studies/" + info["studyID"] + "/signedVideosUrl?moduleName=" + info["moduleName"];
    }
    let xmlHttp = new XMLHttpRequest();
    xmlHttp.onreadystatechange = function() {
      if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
        setS3SignedUrl(element, xmlHttp.responseText);
      }
    };
    xmlHttp.open("GET", theUrl, true);
    xmlHttp.setRequestHeader("clientid", info["clientID"]);
    xmlHttp.send(null);
  }
}

export function loadData(element) {
  if (element) {
    let iframes = element.getElementsByTagName("iframe");
    if (iframes && !iframes.length) {
      return;
    }
    for (let i = 0; i < iframes.length; i++) {
      iframes[i].style.visibility = "hidden";
    }
    getS3SignedUrl(element, iframes);
  }
}
